import { useEffect, useState } from 'react';

const STORAGE_KEY = 'praesidio-geo-banner-dismissed';
const INDIA_TZ = new Set(['Asia/Kolkata', 'Asia/Calcutta']);

/**
 * Timezone-based, dismissible, stored in localStorage.
 * Not a redirect, Googlebot crawls from US IPs, so an IP redirect would
 * hide one surface or the other from the index.
 *
 * Styles are inlined so this can mount on the global lab site without
 * pulling india.css (and its :root tokens) into that document.
 */
export default function GeoBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(STORAGE_KEY) === '1') return;
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (INDIA_TZ.has(tz)) setShow(true);
    } catch {
      /* private mode / no Intl */
    }
  }, []);

  if (!show) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* private mode */
    }
    setShow(false);
  };

  return (
    <div className="geo-banner" role="region" aria-label="India site">
      <style>{`
        .geo-banner {
          background: #1c1915;
          color: #f3efe6;
          font-family: "Plus Jakarta Sans", ui-sans-serif, system-ui, sans-serif;
          font-size: 0.95rem;
          display: flex;
          gap: 1rem;
          align-items: center;
          justify-content: center;
          padding: 0.75rem 1rem;
          flex-wrap: wrap;
          position: relative;
          z-index: 70;
        }
        .geo-banner a { color: inherit; text-decoration: underline; text-underline-offset: 3px; }
        .geo-banner button {
          background: none;
          border: 0;
          cursor: pointer;
          font: inherit;
          color: inherit;
          min-height: 44px;
          min-width: 44px;
        }
      `}</style>
      Looking for the India studio?
      <a href="/in">Open Praesidio Studio →</a>
      <button type="button" onClick={dismiss} aria-label="Dismiss India banner">
        ×
      </button>
    </div>
  );
}
